export default __webpack_public_path__ + "dea6a957a7575253a4e723c3f5780f01.svg";